<template>
	<div class="">
		<div class="case-pice"><span class="case-pice-first">企业变更记录</span> <span class="case-pice-and">/</span> <span class="case-pice-second">企业变更详情</span></div>
		<div class="common-title">
			学员信息
			<el-button style='float: right;' size='small' type="info" @click='goBack()' plain>返回</el-button>
		</div>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content">学员姓名：{{searchData.operator}}</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">身份证号码：{{searchData.operator}}</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">学员编号：{{searchData.studentId}}</div>
			</el-col>
		</el-row>
		<div class="common-title">
			原单位信息
		</div>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content company-title">{{searchData.oldCompanyName}}</div>
			</el-col>
			<el-col :span="14">
				<div class="grid-content company-text">统一社会代码：{{searchData.oldCreditCode}}</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content company-text">所属区县：{{searchData.oldProvinceName}}{{searchData.oldCityName}}{{searchData.oldCountyName}}</div>
			</el-col>
			<el-col :span="14">
				<div class="grid-content company-text">营业执照地址：{{searchData.oldBusinessAddress}}</div>
			</el-col>
		</el-row>
		<el-row :gutter="40" id='imgTooles'>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='searchData.oldBusinessLicenseImg' :src="searchData.oldBusinessLicenseImg" alt="" />
				</div>
				<div class="grid-text">
					营业执照
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='searchData.oldVipFormImg' :src="searchData.oldVipFormImg" alt="" />
				</div>
				<div class="grid-text">
					会员单位申请表
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='searchData.oldTransportLicenseImg' :src="searchData.oldTransportLicenseImg" alt="" />
				</div>
				<div class="grid-text">
					道路运输许可证
				</div>
			</el-col>
		</el-row>
		<div class="common-title">
			现单位信息
		</div>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content company-title">{{searchData.newCompanyName}}</div>
			</el-col>
			<el-col :span="14">
				<div class="grid-content company-text">统一社会代码：{{searchData.newCreditCode}}</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content company-text">所属区县：{{searchData.newProvinceName}}{{searchData.newCityName}}{{searchData.newCountyName}}</div>
			</el-col>
			<el-col :span="14">
				<div class="grid-content company-text">营业执照地址：{{searchData.newBusinessAddress}}</div>
			</el-col>
		</el-row>
		<el-row :gutter="40" id='imgToolesNew'>
			<el-col :span="8">
				<div class="grid-img" @click="preImagenew()">
					<img :data-original='searchData.newVipFormImg' :src="searchData.newBusinessLicenseImg" alt="" />
				</div>
				<div class="grid-text">
					营业执照
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" @click="preImagenew()">
					<img :data-original='searchData.newVipFormImg' :src="searchData.newVipFormImg" alt="" />
				</div>
				<div class="grid-text">
					会员单位申请表
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" @click="preImagenew()">
					<img :data-original='searchData.newTransportLicenseImg' :src="searchData.newTransportLicenseImg" alt="" />
				</div>
				<div class="grid-text">
					道路运输许可证
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import Viewer from 'viewerjs';
	import { getCompanyDetail } from '../../api/main'
	export default {
		data() {
			return {
				searchData: {}
			}
		},
		mounted() {
			this.getDetail();
		},
		methods: {
			preImage() {
				const ViewerDom = document.getElementById('imgTooles');
				const viewer = new Viewer(ViewerDom, {
					url: "data-original"
				});
			},
			preImagenew(){
				const ViewerDom = document.getElementById('imgToolesNew');
				const viewer = new Viewer(ViewerDom, {
					url: "data-original"
				});
			},
			getDetail(){
				getCompanyDetail(this.$store.state.companyChangeId).then(res=>{
					console.log(res)
					this.searchData = res.data;
				})
			},
			goBack(){
				this.$router.go(-1);
			},
			search() {

			},
			handleSizeChange() {},
			handleCurrentChange() {},
			checkMember(row) {
				this.$confirm('确定更正所选项吗？', '企业更正', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '更正成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消更正'
					});
				});
			},
			lookMemberInfo(row) {
				this.$store.state.companyChangeId = row.id;
			},
		}
	}
</script>

<style lang="less">
	.company-change-detail{
		font-size: 16px;
	}
</style>